import ga4 from "@/lib/tracking/ga4Core";

const ACCOUNT_JOURNEY = "wallet_from_account";

export const trackGenericWalletFromAccountClick = ({ source, target }) => {
  const eventName = "click_interaction";
  const eventParams = {
    journey_details: ACCOUNT_JOURNEY,
    target,
    source,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};
